import {
  useSourcingClearUserComparisonMutation,
  useAuctionClearUserComparisonMutation,
} from '@dms/api/core';
import {handleApiError} from '@dms/shared';

import {pushGtmEvent} from 'shared/web';

import {SourcingType} from '../../../hooks/useSourcingType';

export function useClearComparisonList(sourcingType: SourcingType) {
  const [clearClassifieds, classifiedsState] = useSourcingClearUserComparisonMutation();
  const [clearAuctions, auctionsState] = useAuctionClearUserComparisonMutation();

  const clear = () => {
    if (classifiedsState.isLoading || auctionsState.isLoading) {
      return;
    }
    const remove = sourcingType === SourcingType.CLASSIFIEDS ? clearClassifieds : clearAuctions;
    void remove()
      .unwrap()
      .then(() => {
        const event = `sourcing_${sourcingType}_comparison_cleared`;
        pushGtmEvent({event, event_id: event});
      })
      .catch(handleApiError);
  };
  return {clear, isDeleting: classifiedsState.isLoading || auctionsState.isLoading};
}
